import {
  Box,
  Button,
  Grid,
  Text,
  TextInput,
  Select,
  Paper,
  Center,
} from "@mantine/core";
import React from "react";
import { useForm, joiResolver } from "@mantine/form";
import Joi from "joi";
import { showSuccessToast, showErrorToast } from "../../../utilities/Toast";
import { api_saveMaintenance } from "services/master.service";

function WebsiteMaintenancePage() {
  // VALIDATION
  const schema = Joi.object({
    reason: Joi.string().required(),
    etd_maintenance_time: Joi.string().required(),
    site_status: Joi.string().required(),
    maintenance_type: Joi.string().required(),
  });

  const form = useForm({
    initialValues: {
      reason: "",
      etd_maintenance_time: "",
      site_status: "",
      maintenance_type: "",
    },
    validate: joiResolver(schema),
  });

  const submitData = async (values) => {
    await api_saveMaintenance(values).then((res) => {
      if (res.success) {
        showSuccessToast({
          title: "Success",
          message: "Maintenance details saved successfully!",
        });
        form.reset();
      } else {
        showErrorToast({
          title: "Error",
          message: res.message || "Error saving data",
        });
      }
    });
  };

  return (
    <Center mt={30}>
      <Paper
        p={30}
        shadow="md"
        radius="md"
        withBorder
        style={{ width: "100%", maxWidth: "600px" }}
      >
        <Text size={24} weight={700} mb={25} align="center" color="#23582b">
          Website Maintenance Settings
        </Text>

        <form
          onSubmit={form.onSubmit((values) => {
            submitData(values);
          })}
        >
          <Grid gutter="lg">
            {/* Reason */}
            <Grid.Col span={12}>
              <TextInput
                label="Reason for Maintenance"
                placeholder="Enter the reason"
                {...form.getInputProps("reason")}
              />
            </Grid.Col>

            {/* Expected Time */}
            <Grid.Col span={12}>
              <Select
                label="Expected Maintenance Time"
                placeholder="Select Duration"
                data={[
                  { label: "1 Hour", value: "1" },
                  { label: "2 Hours", value: "2" },
                  { label: "3 Hours", value: "3" },
                  { label: "4 Hours", value: "4" },
                  { label: "5 Hours", value: "5" },
                ]}
                {...form.getInputProps("etd_maintenance_time")}
              />
            </Grid.Col>

            {/* Site Status */}
            <Grid.Col span={6}>
              <Select
                label="Site Status"
                placeholder="Select status"
                data={[
                  { value: "running", label: "Running" },
                  { value: "stopped", label: "Stopped" },
                ]}
                {...form.getInputProps("site_status")}
              />
            </Grid.Col>

            {/* Maintenance Type */}
            <Grid.Col span={6}>
              <Select
                label="Maintenance Type"
                placeholder="Select type"
                data={[
                  { value: "website", label: "Website" },
                  { value: "app", label: "App" },
                  { value: "both", label: "Both" },
                ]}
                {...form.getInputProps("maintenance_type")}
              />
            </Grid.Col>
          </Grid>

          <Button type="submit" fullWidth mt={20}>
            Save Maintenance Details
          </Button>
        </form>
      </Paper>
    </Center>
  );
}

export default WebsiteMaintenancePage;
